
const fn = {
    init: () => {
      fn.setupFitVids()
    },

    setupFitVids: () => {

        var embeds = document.querySelectorAll('.ss-htmleditorfield-file.embed');

        /*
         * Loop through the iframes array
         */
        for (var i = 0; i < embeds.length; i++) {
            var iframe = embeds[i].querySelector('iframe');

            if (iframe) {
                var videoRatio        = ( iframe.height / iframe.width ) * 100;
                iframe.style.position = 'absolute';
                iframe.style.top      = '0';
                iframe.style.left     = '0';
                iframe.width          = '100%';
                iframe.height         = '100%';
                var wrap              = document.createElement( 'div' );
                wrap.className        = 'fluid-vids';
                wrap.style.width      = '100%';
                wrap.style.position   = 'relative';
                wrap.style.paddingTop = videoRatio + '%';
                var iframeParent      = iframe.parentNode;
                iframeParent.insertBefore( wrap, iframe );
                wrap.appendChild( iframe );
            }

        }
    }
}

export default {
    can: () => true,
    run: fn.init
}
